import React, { useRef } from "react";
import { useScrollTriggeredCountUp } from "../hooks/countUp";
import { useTranslation } from "react-i18next";

export const DataChart = () => {
  const ref = useRef<HTMLParagraphElement>(null);
  const { t } = useTranslation();
  const chartData = t("chartData.data", { returnObjects: true }) as {
    number: number;
    subtitle: string;
  }[];
  return (
    <div className="flex flex-col place-items-center gap-[28px]">
      <div className="flex flex-col gap-[52px] place-items-center">
        <div className="lg:w-[40%] text-center">
          <p className="text-primary-700 * text-[24px] md:text-[32px] lg:text-[40px] font-600 tracking-[-1.2px]">
            {String(t("chartData.title"))}
          </p>
        </div>
        <div className="flex gap-[10px] md:gap-[26px] lg:gap-[54px] justify-center">
          {chartData.map((eachData, index) => {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const animatedCount = useScrollTriggeredCountUp(
              ref,
              eachData.number
            );

            return (
              <div
                className="flex flex-col gap-[-8px] text-center w-[30%] lg:w-[25%]"
                key={index}
              >
                <p
                  ref={ref}
                  className="text-primary-200 font-700 text-[32px] md:text-[48px] lg:text-[96px]"
                >
                  {animatedCount}
                  {index === 1 ? (
                    <span className="text-[18px] md:text-[20px] lg:text-[36px] font-400">
                      {" "}
                      {String(t("chartData.hours"))}
                    </span>
                  ) : (
                    "%"
                  )}
                </p>

                <p className="text-primary-700 font-400 text-[16px] lg:text-[24px] lg:mt-[-8px]">
                  {eachData.subtitle}
                </p>
              </div>
            );
          })}
        </div>
      </div>
      <div className="mb-[50px] text-neutral-700 text-[13px] font-300">
        {String(t("chartData.source.desc"))}
        <a
          className="underline"
          href={t("chartData.source.link")}
          target="_blank"
          rel="noopener noreferrer"
        >
          {String(t("chartData.source.name"))}
        </a>
      </div>
    </div>
  );
};
